let PlainActionDisclosureValue = /*#__PURE__*/function (PlainActionDisclosureValue) {
  PlainActionDisclosureValue["Down"] = "down";
  PlainActionDisclosureValue["Up"] = "up";
  PlainActionDisclosureValue["Select"] = "select";
  PlainActionDisclosureValue["ChevronDown"] = "chevronDown";
  PlainActionDisclosureValue["ChevronUp"] = "chevronUp";
  PlainActionDisclosureValue["CaretDown"] = "caretDown";
  PlainActionDisclosureValue["CaretUp"] = "caretUp";
  PlainActionDisclosureValue["ChevronDownTiny"] = "chevronDownTiny";
  return PlainActionDisclosureValue;
}({});
let BackgroundColorValue = /*#__PURE__*/function (BackgroundColorValue) {
  BackgroundColorValue["Subdued"] = "subdued";
  BackgroundColorValue["Dark"] = "dark";
  BackgroundColorValue["Grey"] = "grey";
  return BackgroundColorValue;
}({});

export { BackgroundColorValue, PlainActionDisclosureValue };
